import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import Metatags from '~/components/Metadata/Metatags'
import { DefaultLayout } from '~/shared/layouts'

import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'

import { AppLanguage } from '~/types/locale'
import { usePageTitle } from '~/utils/tags'
import { Cookies } from '~/static-pages/Cookies/pages/Cookies.page'

const CookiePolicyPage: NextPage = () => {
  const { t } = useTranslation('cookies')
  const pageTitle = usePageTitle(t('title'))

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={pageTitle} />

      <DefaultLayout zeroPadding>
        <Cookies />
      </DefaultLayout>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext<{ locale: AppLanguage }>) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
        'cookies',
      ])),
    },
  }
}

export default CookiePolicyPage
